import React, { ReactNode } from 'react';

import { themeData } from '@totem/styles/theme';

const styles = {
  value: {
    color: themeData.token.colorPrimary,
    fontSize: themeData.token.fontSize,
    marginLeft: '.5em',
  },
};

type Props = {
  children: ReactNode;
  style?: React.CSSProperties;
};

const HeaderValue = ({ children, style }: Props) => {
  return <div style={{ ...styles.value, ...style }}>{children}</div>;
};

export default HeaderValue;
